import { SelectOption } from "@kanda-libs/ks-component-ts";

export const MODAL_ID = "add-company-risk-status-modal";

export const LEVEL_OPTIONS: SelectOption[] = [
  {
    name: "Green",
    value: "green",
  },
  {
    name: "Yellow",
    value: "yellow",
  },
  {
    name: "Red",
    value: "red",
  },
];
